import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import {
  Box,
  VStack,
  HStack,
  Button,
  Icon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { FiHome } from 'react-icons/fi';
import { ERROR_CODE } from '@/constants/errorCode';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const [errorDetails, setErrorDetails] = useState({
    code: 'E_9000',
    message: '',
    timestamp: new Date().toISOString(),
  });

  const handleGoHome = useCallback(() => {
    window.location.href = `/top`;
  }, []);

  // Auto redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleGoHome();
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [handleGoHome]);

  useEffect(() => {
    // Get error code from URL params
    const errorCode = searchParams.get('code') || 'E_9000';
    const errorMessage = searchParams.get('message') || '';

    // Validate error code
    const validErrorCode = Object.keys(ERROR_CODE).includes(errorCode)
      ? errorCode
      : 'E_9000';

    setErrorDetails({
      code: validErrorCode,
      message: errorMessage,
      timestamp: new Date().toISOString(),
    });
  }, [searchParams]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap={4}
      sx={{
        minHeight: ['100dvh', '100vh'],
      }}
    >
      {/* Error Details Card */}
      <Box shadow="sm">
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <Box>
            <AlertTitle>Error Code: {errorDetails.code}</AlertTitle>
            <AlertDescription>
              {errorDetails.message || t('error-title')}
            </AlertDescription>
          </Box>
        </Alert>
      </Box>

      {/* Action Buttons */}
      <VStack spacing={4}>
        <HStack spacing={4} justify="center" wrap="wrap">
          <Button
            colorScheme="teal"
            size="lg"
            leftIcon={<Icon as={FiHome} />}
            onClick={handleGoHome}
            minW="150px"
          >
            {t('error-go-home')}
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default ErrorPage;
